**Average Drawdown** is defined as the average of all drawdowns with reference over
the time period analyzed.
